import { matchPath, type useLocation } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';

const getOffsetByPage = (location: ReturnType<typeof useLocation>): string => {
  const defaultOffset = 'var(--header-height)';

  const isWorkshopPage = !!matchPath(
    `${AppRoute.WORKSHOP}/:id`,
    location.pathname,
  );

  if (isWorkshopPage) {
    return 'calc(var(--workshop-title-height, 0px) + var(--header-height,  0px))';
  }

  const isFactoryPage = !!matchPath(
    `${AppRoute.FACTORY}/:id`,
    location.pathname,
  );

  if (isFactoryPage) {
    return 'calc(var(--factory-title-height, 0px) + var(--header-height,  0px))';
  }

  return defaultOffset;
};

export { getOffsetByPage };
